<template>
  <div class="bg-white p-4 shadow-sm h-max">
    <div class="w-full flex gap-4 items-center">
      <img :src="detail?.product?.thumbnail" class="w-[12.5rem] h-full rounded" alt="" />
      <div class="w-full">
        <div class="flex justify-between items-center mb-2">
          <p class="font-bold text-main-color text-xl">{{ detail?.product?.name }}</p>
          <button
            @click="deleteCartItem(0)"
            class="bg-[#EB5757] p-2 flex items-center justify-center rounded"
          >
            <IconTrash></IconTrash>
          </button>
        </div>
        <div v-if="detail?.size" class="flex gap-1">
          <p class="font-light text-[#333]">{{ $t('page.size') }}:</p>
          <span class="text-[#333] font-bold">{{ detail?.size }}</span>
        </div>

        <div class="flex justify-between items-center">
          <p v-if="!detail?.discount_percent" class="text-[#409DBA] font-bold text-lg">
            {{ formatNumber(detail?.price) }} TMT
          </p>

          <p v-else class="text-[#409DBA] font-bold text-lg leading-4">
            {{ formatNumber(detail?.price) }} TMT
            <br />
            <span class="line-through font-semibold text-base text-[#CB3131]">
              {{ formatNumber(detail?.original_price) }} TMT
            </span>
          </p>

          <div class="flex gap-1 font-bold">
            <button
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              @click="updateCartItem(detail?.quantity - 1)"
            >
              -
            </button>
            <span
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              >{{ detail?.quantity }}</span
            >
            <button
              class="text-main-color w-[1.875rem] h-[1.875rem] flex items-center justify-center bg-[#e3e3e3] rounded"
              @click="updateCartItem(detail?.quantity + 1)"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import IconTrash from '@icons/IconTrash.vue';
import { formatNumber } from '@/helpers';

export default {
  name: 'CartCard',
  components: {
    IconTrash,
  },
  props: {
    detail: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    formatNumber,
    deleteCartItem(qty) {
      this.$store.deleteCartItem(this.detail?.id, qty).then(e => {
        this.loading = false;
      });
    },
    updateCartItem(qty) {
      this.loading = true;
      if (qty === 0) {
        this.deleteCartItem(this.detail?.id, qty);
        return;
      }
      this.$store.updateCartItem(this.detail?.id, qty).then(e => {
        this.loading = false;
      });
    },
  },
  computed: {},
  created() {},
};
</script>
